interface ActivityItemProps {
  avatar?: string;
  icon?: React.ReactNode;
  name: string;
  time: string;
  action: string;
  status: 'done' | 'critical' | 'active' | 'new';
}

export default function ActivityItem({ avatar, icon, name, time, action, status }: ActivityItemProps) {
  const statusColors = {
    done: 'bg-green-100 text-green-700',
    critical: 'bg-red-100 text-red-700',
    active: 'bg-blue-100 text-blue-700',
    new: 'bg-gray-100 text-gray-700'
  };

  const statusLabels = {
    done: 'Done',
    critical: 'Critical',
    active: 'Active',
    new: 'New'
  };

  return (
    <div className="flex gap-3 group cursor-pointer">
      {avatar ? (
        <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
          <img src={avatar} alt={name} className="w-full h-full object-cover" />
        </div>
      ) : (
        <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center text-gray-600 flex-shrink-0">
          {icon}
        </div>
      )}

      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2 mb-1">
          <p className="text-sm font-medium text-gray-900">{name}</p>
          <span className="text-xs text-gray-500 whitespace-nowrap">{time}</span>
        </div>
        <p className="text-xs text-gray-600 mb-2">{action}</p>
        <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium ${statusColors[status]}`}>
          {statusLabels[status]}
        </span>
      </div>
    </div>
  );
}
